import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Buttons from "./Buttons";
import PopModal from "./PopModal";
import routes from "../routes/routes";
import { useModal } from "../context/ModalContext"; 

function NavigationBar() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const location = useLocation();
  const { showModal, setShowModal } = useModal(); 

  const handleCloseOffcanvas = () => setShowOffcanvas(false);

  const handleGetStartedClick = () => {
    setShowOffcanvas(false); 
    setTimeout(() => setShowModal(true), 300);
  };

  return (
    <>
      <Navbar expand="lg" className="px-lg-5">
        <Container className="navbar_bg " fluid>
          <Navbar.Brand as={Link} to="/">
            <img
              alt="Logo"
              src={require("../assest/images/org-logo.png")}
              className="org-logo align-top me-2"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={() => setShowOffcanvas(true)} />

          <Navbar.Offcanvas
            id="offcanvasNavbar"
            placement="end"
            show={showOffcanvas}
            onHide={handleCloseOffcanvas}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">Menu</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="ms-auto">
                {routes.map((link, index) => (
                  <Nav.Link
                    key={index}
                    as={Link}
                    to={link.path}
                    onClick={handleCloseOffcanvas}
                    className={location.pathname === link.path ? "active" : ""}
                  >
                    {link.label}
                  </Nav.Link>
                ))}
              </Nav>
              <Buttons btnLabel="Get Started" className="get-start ms-lg-5" onClick={handleGetStartedClick} />
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
      <PopModal show={showModal} handleClose={() => setShowModal(false)} />
    </>
  );
}

export default NavigationBar;
